import React from 'react';

const CaretRight = (props: object) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.9722 9.59912L7.34717 15.2241C7.18866 15.3826 6.97367 15.4717 6.74951 15.4717C6.52535 15.4717 6.31036 15.3826 6.15185 15.2241C5.99335 15.0656 5.9043 14.8506 5.9043 14.6265C5.9043 14.4023 5.99335 14.1873 6.15185 14.0288L11.1799 9.00217L6.15326 3.97412C6.07478 3.89563 6.01252 3.80246 5.97004 3.69991C5.92757 3.59737 5.9057 3.48746 5.9057 3.37646C5.9057 3.26547 5.92757 3.15556 5.97004 3.05301C6.01252 2.95047 6.07478 2.85729 6.15326 2.77881C6.23175 2.70032 6.32492 2.63806 6.42747 2.59559C6.53001 2.55311 6.63992 2.53125 6.75092 2.53125C6.86191 2.53125 6.97182 2.55311 7.07437 2.59559C7.17691 2.63806 7.27009 2.70032 7.34857 2.77881L12.9736 8.40381C13.0521 8.48229 13.1144 8.5755 13.1569 8.67811C13.1994 8.78072 13.2212 8.89071 13.221 9.00176C13.2209 9.11281 13.1989 9.22274 13.1561 9.32525C13.1134 9.42775 13.0509 9.52083 12.9722 9.59912Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CaretRight;
